import { useMemo, useState } from 'react';
import {
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

import CategoryChecks from './CategoryChecks';
import CategoryList from './CategoryList';
import cyberSecurityData, { getCyberSecurityCategory, getCyberSecurityCheck } from './cyberSecurityData';
import FindingDetail from './FindingDetail';
import OverviewFindings from './OverviewFindings';

const DigitalIdentity = () => {
    const [activeCategoryId, setActiveCategoryId] = useState('overview');
    const [selectedCheckId, setSelectedCheckId] = useState(null);
    const category = getCyberSecurityCategory(activeCategoryId);
    const selected = useMemo(() => {
        if (!selectedCheckId) return { category, check: null };

        if (activeCategoryId === 'overview') {
            const finding = cyberSecurityData.overviewFindings.find((item) => item.id === selectedCheckId);

            return getCyberSecurityCheck(finding?.categoryId, selectedCheckId);
        }

        return getCyberSecurityCheck(activeCategoryId, selectedCheckId);
    }, [activeCategoryId, category, selectedCheckId]);

    const selectCategory = (categoryId) => {
        setActiveCategoryId(categoryId);

        if (categoryId === 'overview') {
            setSelectedCheckId(null);

            return;
        }

        const nextCategory = getCyberSecurityCategory(categoryId);
        const firstIssue = nextCategory?.checks.find((check) => check.status !== 'passed');

        setSelectedCheckId(firstIssue?.id || null);
    };

    const selectCheck = (check) => {
        setSelectedCheckId(check.id);
    };

    const selectOverviewFinding = (finding) => {
        setSelectedCheckId(finding.id);
    };

    const showDetail = activeCategoryId !== 'overview'
        || Boolean(selectedCheckId);

    return (
        <Row className="cyber-security">
            <Col lg="3">
                <Card>
                    <CardBody>
                        <CategoryList
                            activeCategoryId={activeCategoryId}
                            data={cyberSecurityData}
                            onSelectCategory={selectCategory}
                        />
                    </CardBody>
                </Card>
            </Col>

            <Col lg={showDetail ? 5 : 9}>
                <Card>
                    <CardBody>
                        {activeCategoryId === 'overview' ? (
                            <OverviewFindings
                                findings={cyberSecurityData.overviewFindings}
                                onSelectFinding={selectOverviewFinding}
                                selectedFindingId={selectedCheckId}
                                summary={cyberSecurityData.summary}
                            />
                        ) : (
                            <CategoryChecks
                                category={category}
                                onSelectCheck={selectCheck}
                                selectedCheckId={selectedCheckId}
                            />
                        )}
                    </CardBody>
                </Card>
            </Col>

            {showDetail && (
                <Col lg="4">
                    <Card>
                        <CardBody>
                            <FindingDetail
                                category={selected.category || category}
                                check={selected.check}
                                onClose={selectedCheckId ? () => setSelectedCheckId(null) : null}
                            />
                        </CardBody>
                    </Card>
                </Col>
            )}
        </Row>
    );
};

export default DigitalIdentity;
